import { memo } from "react";
import { TextField } from "ui/components/TextField/TextField";
import { Dropdown } from "ui/components/Dropdown/Dropdown";
import { MarketplaceExtraData } from "../../../types";
import { ChipToggle, SectionCard } from "../primitives";
import {
  ECO_CATEGORY_OPTIONS,
  OWNER_COUNT_OPTIONS,
  REGISTERED_UNTIL_OPTIONS,
} from "services/api/sales/listings/consts";

interface Props {
  values: MarketplaceExtraData;
  onChange: (patch: Partial<MarketplaceExtraData>) => void;
}

const AdditionalDataSection: React.FC<Props> = ({ values, onChange }) => {
  const handleText = (e: React.ChangeEvent<HTMLInputElement>) =>
    onChange({ [e.target.name]: e.target.value } as Partial<MarketplaceExtraData>);

  const handleDropdown = (_e: any, name: string, item: { value: string }) =>
    onChange({ [name]: item.value } as Partial<MarketplaceExtraData>);

  const toggle = (name: "hasGas" | "garaged" | "serviceBook") =>
    onChange({ [name]: !values[name] } as Partial<MarketplaceExtraData>);

  return (
    <SectionCard title="Ostali podaci o vozilu">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
        <div><TextField type="number" name="fuelConsumption" label="Potrošnja goriva (l/100km)" value={values.fuelConsumption} onChange={handleText} /></div>
        <div><TextField type="number" name="co2Emission" label="Prosječna emisija CO₂ (g/km)" value={values.co2Emission} onChange={handleText} /></div>
        <div><Dropdown name="ecoCategoryCode" label="Ekološka kategorija" value={values.ecoCategoryCode} options={ECO_CATEGORY_OPTIONS} onChange={handleDropdown} /></div>
        <div><TextField type="text" name="inTrafficSinceYear" label="Vozilo u prometu od (godina)" value={values.inTrafficSinceYear} onChange={handleText} /></div>
        <div><TextField type="text" name="firstRegistrationYearRH" label="Godina 1. registracije u RH" value={values.firstRegistrationYearRH} onChange={handleText} /></div>
        <div><Dropdown name="registeredUntil" label="Registrirano do" value={values.registeredUntil} options={REGISTERED_UNTIL_OPTIONS} onChange={handleDropdown} /></div>
        <div><Dropdown name="ownerCountCode" label="Vlasnik" value={values.ownerCountCode} options={OWNER_COUNT_OPTIONS} onChange={handleDropdown} /></div>
        <div><TextField type="text" name="chassisNumber" label="Broj šasije (VIN)" value={values.chassisNumber} onChange={handleText} /></div>
        <div><TextField type="text" name="internalCode" label="Interna šifra / registracija" value={values.internalCode} onChange={handleText} /></div>
      </div>

      <div className="mt-4 flex flex-wrap gap-2">
        <ChipToggle label="Plin (LPG/CNG)" selected={values.hasGas} onToggle={() => toggle("hasGas")} />
        <ChipToggle label="Garažiran" selected={values.garaged} onToggle={() => toggle("garaged")} />
        <ChipToggle label="Servisna knjiga" selected={values.serviceBook} onToggle={() => toggle("serviceBook")} />
      </div>
    </SectionCard>
  );
};

export default memo(AdditionalDataSection);
